import React, { useEffect, useState } from "react";
import LeftSponsers from "./../leftSponsers/leftSponsers";
import * as api from "./../../api/api";
import Banner from "./../banner/banner";

//BACKDROP STYLING
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    backgroundColor: "white",
  },
}));

export default function AboutUs() {
  const classes = useStyles();
  const [aboutUs, setAboutUs] = useState("");
  const [loader, setLoader] = useState(true);
  useEffect(() => {
    document.title = "121five.com - About Us";
    window.scrollTo(0, 0);
    aboutUsApi();
  }, []);

  const aboutUsApi = async () => {
    try {
      let response = await api.aboutUs();
      if (response) {
        setAboutUs(response);
        setLoader(false);
      }
    } catch (e) {}
  };

  return (
    <div>
      <section className="sponsor py-5">
        <div className="container">
          <div className="row justify-content-lg-between justify-content-center">
            <div className="col-lg-3 col-md-6">
              <div className="left-sponsor">
                <LeftSponsers />
              </div>
            </div>

            <div className="col-lg-9 col-md-12">
              <div className="about-us-area">
                <div className="single-about">
                  <h4>121five.com Privacy Policy</h4>
                  <p>
                    121five.com seeks to ensure that all content and information
                    published at this Web site is current and accurate. The
                    information at 121five.com does not in any way constitute
                    legal or professional advice and 121five.com cannot be held
                    liable for actions arising from its use. In addition,
                    121five.com cannot be held responsible for the contents of
                    any externally linked pages.
                    <br />
                    <br /> Links to external, or third party Web sites, are
                    provided solely for visitors' convenience. Links taken to
                    other sites are done so at your own risk and 121five.com
                    accepts no liability for any linked sites or their content.
                    <br />
                    <br />
                    When you access an external Web site, keep in mind that
                    121five.com has no control over its content. Any link from
                    121five.com to an external Web site does not imply or mean
                    that 121five.com endorses or accepts any responsibility for
                    the content or the use of such Web site. 121five.com does
                    not give any representation regarding the quality, safety,
                    suitability, or reliability of any external Web sites or any
                    of the content or materials contained in them. It is
                    important for users to take necessary precautions,
                    especially to ensure appropriate safety from viruses, worms,
                    Trojan horses and other potentially destructive items.
                    <br />
                    <br /> When visiting external Web sites, users should review
                    those Websites' privacy policies and other terms of use to
                    learn more about, what, why and how they collect and use any
                    personally identifiable information.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress />
      </Backdrop>
    </div>
  );
}
